<template>
  <div class="hero_slider">
    <div
      class="uk-position-relative uk-visible-toggle uk-light slider_main"
      tabindex="-1"
      uk-slideshow="autoplay: false;autoplay-interval:5000;start:0"
    >
      <ul class="uk-slideshow-items">
        <template v-for="slider in get_slider_list">
          <template v-if="slider.media_type=='mp4'">
              <li :key="slider.id">
          <video class="video_slider" :src="slider.bg_img" autoplay loop muted playsinline></video>
          <div class="slide_single">
            <div class="content_slide">
              <h2>{{slider.title2}}</h2>
              <h1>{{slider.title1}}</h1>
               <router-link v-if="slider.btn_slider" class="squ" :to="slider.btn_slider.link">{{slider.btn_slider.text}}</router-link>
            </div>
          </div>
        </li>
          </template>
          <template v-else>
              <li :key="slider.id">
          <img
            class="img_slider"
            :src="slider.bg_img"
            alt="slider_img"
            uk-cover
          />
          <div class="slide_single">
            <div class="content_slide">
              <h2>{{slider.title2}}</h2>
              <h1>{{slider.title1}}</h1>
               <router-link v-if="slider.btn_slider" class="squ" :to="slider.btn_slider.link">{{slider.btn_slider.text}}</router-link>
            </div>
          </div>
        </li>
          </template>
        </template>
         <!-- <li>
          <img
            class="img_slider"
            src="https://img1.wsimg.com/isteam/ip/ca274e7e-3bc0-4ba3-9dfb-d3d734b4726f/shutterstock_1879119892.jpg/:/cr=t:0%25,l:0%25,w:100%25,h:100%25"
            alt=""
            uk-cover
          />
          <div class="slide_single">
            <div class="content_slide">
              <h2>VELKOMMEN TIL BPST</h2>
              <h1>Profesjonell Bilpleie Og Spesiafisttjenester</h1>
              <a class="squ" href="#">SJEKK VÅRE PROSJEKTER</a>
            </div>
          </div>
        </li> -->
      </ul>

      <a
        class="uk-position-center-left uk-position-small"
        href="#"
        uk-slidenav-previous
        uk-slideshow-item="previous"
      ></a>
      <a
        class="uk-position-center-right uk-position-small"
        href="#"
        uk-slidenav-next
        uk-slideshow-item="next"
      ></a>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import $ from 'jquery';
export default {
  name: "heroArea",
    computed:{
    ...mapGetters({
        get_slider_list:'get_slider_list',
    })
  },
    methods:{
    ...mapActions({
        slider_api:'slider_api',
    }),
    },
    mounted(){
       this.slider_api().then(()=>{
          const uk = this.uk;
        uk.slideshow($('.slider_main'), {
          index:0
        });
//         uk.util.on('.slider_main ', 'beforeitemshow' , function(e){
//                 console.log(e.detail[0].index , 'indexzz');
//                 uk.slideshow($('.slider_main')).show(0);
// });
       });
       console.log($('.slider_main'))

    }
};
</script>
<style lang="scss" scoped>
.hero_slider {
  position: relative;
  left: 0;
  top: 0;
  margin-top: -130px;
  width: 100%;
  height: 100%;
}
.video_slider{
  object-fit: cover;
   min-height: 100vh !important;
  height: 100vh !important;
}
.uk-slideshow-items,
.img_slider {
  min-height: 100vh !important;
  height: 100vh !important;
  li {
    height: 100%;
    &::before {
      content: "";
      background-color: rgb(27, 27, 27);
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      opacity: 0.7;
      z-index: 1;
    }
    .slide_single {
      position: relative;
      z-index: 2;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 40px;
      text-align: center;
      max-width: 650px;
      margin: 0 auto;
      padding-top: 150px;
      h1 {
        font-size: 60px;
        font-family: "Oswald", sans-serif;
        font-weight: 700;
        text-transform: uppercase;
        line-height: 1.1;
        margin: 0;
      }
      h2 {
        letter-spacing: 2px;
        color: var(--active_color);
        font-size: 0.75rem;
        font-weight: 700;
        font-family: "Oswald", sans-serif;
        text-transform: uppercase;
      }
  
    }
  }
}



// STYLE MEDIA QUERY
@media(max-width:992px){
    .uk-slideshow-items li .slide_single h1 {
        font-size: 50px;
    }
}
@media(max-width:767px){
    .uk-slideshow-items li .slide_single h1 {
        font-size: 30px;
    }
    .uk-slideshow-items, .img_slider{
    min-height: 80vh !important;
    height: 80vh !important;
}
}
</style>
